export enum NutrientSource {
  Canada = 0,
  US = 1,
  UK = 2,
  Branded = 3,
  Foundation = 4,
  SugarAlcohols = 5,
  Fndds = 6
};
